/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    .config([
        "$oidcProvider",
        function (oidcProvider) {
            oidcProvider.configure({
                app_prefix: "roger",
                authority: __ROGER__.auth.authority,
                client_id: __ROGER__.auth.clientId,
                grant_type: "hybrid",
                scope: "openid profile roger offline_access",
                sessions: 4,
                jwks_uri_path: ""
            });
        }]);